import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '@/lib/store/authStore'
import {
  cpGetLineConfig,
  cpUpdateLineConfig,
  type LineConfigUpdate,
} from '@/lib/api/controlPlaneClient'

export function useLineConfig() {
  const queryClient = useQueryClient()
  // Store-scoped: each store manages its own LINE Login channel (QF-903).
  // null/undefined = primary store (single-store tenants unchanged).
  const activeStorefrontKey = useAuthStore((s) => s.activeStorefrontKey)
  const queryKey = ['line-config', activeStorefrontKey ?? 'primary'] as const

  const configQuery = useQuery({
    queryKey,
    queryFn: () => cpGetLineConfig(activeStorefrontKey),
  })

  const saveMutation = useMutation({
    mutationFn: (data: LineConfigUpdate) => cpUpdateLineConfig(data, activeStorefrontKey),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey })
    },
  })

  return {
    config: configQuery.data ?? null,
    isLoading: configQuery.isLoading,

    save: saveMutation.mutate,
    isSaving: saveMutation.isPending,
    saveError: saveMutation.error?.message ?? null,
  }
}
